import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import AuthPage from '@/components/Authorization'
import Users from '@/components/Admin/Users/Users.vue'
import Timesheet from '@/components/Admin/TimeSheets/Timesheet.vue'
import AdminComponents from '../components/Admin/Components'
import Dashboard from '@/components/Admin/Dashboard/Dashboard.vue'
import NowActivity from '@/components/Admin/Dashboard/Activity/NowActivity.vue'
import Projects from '@/components/Admin/Projects/Projects.vue'
import Reports from '@/components/Admin/Reports/Reports.vue'
import UsersPerProject from '@/components/Admin/Analytics/UsersPerProject/UsersPerProject.vue';
import ProjectPerUsers from '@/components/Admin/Analytics/ProjectPerUsers/ProjectPerUsers.vue';


Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Hello',
            component: HelloWorld
        },
        {
            path: '/auth',
            name: 'AuthPage',
            component: AuthPage
        },
        {
            path: '/admin/',
            name: 'Home',
            component: AdminComponents.MainTemplate,
            children: [
                //-----------------------Users----------------
                {

                    path: '/admin/users',
                    component: Users
                },
                {

                    path: '/admin/projects',
                    component: Projects
                },
                {

                    path: '/admin/dashboard',
                    component: Dashboard
                },
                {

                    path: '/admin/timesheet',
                    component: Timesheet
                },
                {

                    path: '/admin/reports',
                    component: Reports
                },
                {

                    path: '/admin/analytics/users-per-project',
                    component: UsersPerProject
                },
                {

                    path: '/admin/analytics/projects-per-user',
                    component: ProjectPerUsers
                },
            ]

        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js